import React from 'react';
import Image from 'react-bootstrap/Image';
import Logo from "../../../assets/images/logo-boy-prepared-50.png";

const SmallMnemonic = () => (
  <Image src={Logo} />
);

export default SmallMnemonic;